import React, { Fragment, useCallback } from 'react';
import { useInfo, useTabInfo, useInventorySave } from 'hooks/query/useJob';
import { useParams } from 'react-router-dom';
import { useModal } from 'context/modal';
import Icon from 'components/Icon';
import { prepareDataToSubmit } from 'pages/modal/Inventory/utils';

const Inventory = ({ type, field }) => {
  const { id, tab } = useParams();
  const { open, modalNames } = useModal();

  const { mutate: saveInventory } = useInventorySave(id, tab);

  const {
    data: { job_inventory: jobInventory },
  } = useTabInfo(id, tab);

  const { data: infoData } = useInfo(id);

  const est_inventory_items = jobInventory['estimated'].reduce((sum, item) => sum + parseInt(item.qty), 0);
  const fin_inventory_items = jobInventory['final'].reduce((sum, item) => sum + parseInt(item.qty), 0);
  const est_inventory_total = jobInventory['estimated'].reduce((sum, item) => sum + item.qty * Number(item.volume), 0);
  const fin_inventory_total = jobInventory['final'].reduce((sum, item) => sum + item.qty * Number(item.volume), 0);

  const deleteInventoryItems = useCallback(
    (type, itemId) => {
      saveInventory({
        job_id: id,
        job_inventory: { estimated: type === 'estimated' ? [] : jobInventory[type], final: [] },
      });
    },
    [id, jobInventory, saveInventory]
  );

  const openInventoryFinalModal = () => {
    open(modalNames.inventory, {
      type: 'final',
      jobID: id,
      companyID: infoData?.job_info.company_id,
      jobInventory: jobInventory.final,
      onSubmit: (data, options) => {
        const prepared = prepareDataToSubmit(data);
        saveInventory({ job_id: id, job_inventory: { estimated: jobInventory['final'], final: prepared } }, options);
      },
    });
  };

  const openInventoryEstimatedModal = () => {
    open(modalNames.inventory, {
      type: 'estimated',
      jobID: id,
      companyID: infoData?.job_info.company_id,
      jobInventory: jobInventory.estimated,
      onSubmit: (data, options) => {
        const prepared = prepareDataToSubmit(data);
        saveInventory({ job_id: id, job_inventory: { estimated: prepared, final: prepared } }, options);
      },
    });
  };

  return (
    <Fragment>
      <div className="new-table--row bcg-light">
        <div className="new-table--row--item justify-content-center w40">
          <b>Inventory</b>
        </div>
        <div className="new-table--row--item w30 justify-content-center no-padding">
          <button type="button" className="btn p20 flex-grow-1 d-flex text-center" onClick={openInventoryEstimatedModal}>
            <Icon icon="add" size={16} />
          </button>
        </div>
        <div className="new-table--row--item w30 justify-content-center no-padding">
          <button type="button" className="btn p20 flex-grow-1 d-flex text-center" onClick={openInventoryFinalModal}>
            <Icon icon="add" size={16} />
          </button>
        </div>
      </div>

      {(+est_inventory_items !== 0 || +fin_inventory_items !== 0) && (
        <Fragment>
          <div className="new-table--row">
            <div className="new-table--row--item justify-content-center w40" />
            <div className="new-table--row--item no-side-shadows w60 justify-content-center no-padding">
              {+est_inventory_items !== 0 ? (
                <div className="new-table--row--item w50 justify-content-center no-padding">
                  <div className="new-table--row">
                    <div className="new-table--row--item w70 justify-content-center no-side-shadows">
                      <button className="show-modal" onClick={() => deleteInventoryItems('estimated')}>
                        <Icon size={18} icon="delete" title="Delete" />
                      </button>
                      <span>{`${est_inventory_items} items`}</span>
                    </div>
                    <div className="new-table--row--item w30 justify-content-center no-side-shadows">
                      <b>{est_inventory_total}</b>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="new-table--row" />
              )}

              {+fin_inventory_items !== 0 ? (
                <div className="new-table--row--item w50 justify-content-center no-padding">
                  <div className="new-table--row">
                    <div className="new-table--row--item w70 justify-content-center no-side-shadows">
                      <button className="show-modal" onClick={() => deleteInventoryItems('final')}>
                        <Icon size={18} icon="delete" title="Delete" />
                      </button>
                      <span>{`${fin_inventory_items} items`}</span>
                    </div>
                    <div className="new-table--row--item w30 justify-content-center no-side-shadows">
                      <b>{fin_inventory_total}</b>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="new-table--row" />
              )}
            </div>
          </div>
        </Fragment>
      )}
    </Fragment>
  );
};

export default Inventory;
